import React, { useState } from "react";
import Card from "../../components/Card";
import Action from "../../components/Action";
import RadioQuestion from "../../components/RadioQuestion";
import TextQuestion from "../../components/TextQuestion";
import ScrollToTop from "../../components/utils/ScrollToTop";
import { YES_NO_OPTIONS } from "../../constants";
import Image from "../../components/Image";
import imageCatAndHousePlant from "../../images/cat-and-houseplant.png";
import { isMoneyValid, normaliseMoney } from "../../shared/utils/moneyUtils";

const Remortgage = ({ remortgage, onStepComplete }) => {
  const [formState, setFormState] = useState({
    estimateRemortgagingAnotherPropertyAmount: remortgage?.estimateRemortgagingAnotherPropertyAmount || "",
    remortgageComplete: remortgage?.remortgageComplete ?? null,
  });
  const [errors, setErrors] = useState({});
  const [errorMessages, setErrorMessages] = useState({
    estimateRemortgagingAnotherPropertyAmount: "Please fill this in",
    remortgageComplete: "Please choose an option",
  });

  const handleInputChange = (field) => (value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
  };

  const handleValidation = () => {
    let newErrors = {};
    let newErrorMessages = { ...errorMessages };
    let formIsValid = true;

    if (!formState.estimateRemortgagingAnotherPropertyAmount) {
      newErrors.estimateRemortgagingAnotherPropertyAmount = true;
      formIsValid = false;
    }

    if (
      formState.estimateRemortgagingAnotherPropertyAmount !== "" &&
      !isMoneyValid(formState.estimateRemortgagingAnotherPropertyAmount)
    ) {
      newErrors.estimateRemortgagingAnotherPropertyAmount = true;
      newErrorMessages.estimateRemortgagingAnotherPropertyAmount = "Please enter a valid amount";
      formIsValid = false;
    }

    if (formState.remortgageComplete === null) {
      newErrors.remortgageComplete = true;
      formIsValid = false;
    }

    setErrors(newErrors);
    setErrorMessages(newErrorMessages);
    return formIsValid;
  };

  const handleFieldValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    setErrors((prev) => {
      let newErrors = { ...prev };

      if (!isBlur) {
        newErrors[field] = false;
      } else {
        if (!formState[field] && formState[field] !== false) {
          newErrors[field] = true;
        }
      }

      return newErrors;
    });
  };

  const handleMoneyValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    setErrors((prev) => {
      let newErrors = { ...prev };

      if (!isBlur) {
        newErrors[field] = false;
      } else {
        if (!formState[field]) {
          newErrors[field] = true;
        } else if (!isMoneyValid(formState[field])) {
          newErrors[field] = true;
        }
      }

      return newErrors;
    });
    setErrorMessages((prev) => {
      let newErrorMessages = { ...prev };

      if (isBlur) {
        if (!formState[field]) {
          newErrorMessages[field] = "Please fill this in";
        } else if (!isMoneyValid(formState[field])) {
          newErrorMessages[field] = "Please enter a valid amount";
        }
      }

      return newErrorMessages;
    });
  };

  const saveRemortgage = (event) => {
    event.preventDefault();

    if (handleValidation()) {
      onStepComplete({
        remortgage: {
          estimateRemortgagingAnotherPropertyAmount: normaliseMoney(
            formState.estimateRemortgagingAnotherPropertyAmount,
          ),
          remortgageComplete: formState.remortgageComplete,
        },
      });
    }
  };

  return (
    <React.Fragment>
      <ScrollToTop />
      <Card title="Tell us about your remortgage" removeTopPadding>
        <TextQuestion
          question="How much money from your remortgage will you contribute to your purchase?"
          value={formState.estimateRemortgagingAnotherPropertyAmount}
          valueEntered={handleInputChange("estimateRemortgagingAnotherPropertyAmount")}
          validate={handleMoneyValidation("estimateRemortgagingAnotherPropertyAmount")}
          validationError={
            errors.estimateRemortgagingAnotherPropertyAmount
              ? errorMessages.estimateRemortgagingAnotherPropertyAmount
              : null
          }
        />

        <RadioQuestion
          question="Has your remortgage already completed?"
          options={YES_NO_OPTIONS}
          inline={true}
          name="remortgageComplete"
          selected={formState.remortgageComplete}
          optionSelected={handleInputChange("remortgageComplete")}
          validate={handleFieldValidation("remortgageComplete")}
          validationError={errors.remortgageComplete ? errorMessages.remortgageComplete : null}
        />

        <Action onClick={saveRemortgage}>Continue</Action>
      </Card>
      <Image src={imageCatAndHousePlant} />
    </React.Fragment>
  );
};

export default Remortgage;
